import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SizeProp } from "@fortawesome/fontawesome-svg-core/index";
import * as React from "react";
import {
  faToggleOn,
  faToggleOff,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

import "./style.scss";

interface IToggleComponentProps {
  enabled?: boolean;
  onToggle?: (newState: boolean) => void;
  iconOn?: IconDefinition;
  iconOff?: IconDefinition;
  color?: string;
  size?: "extraSmall" | "small" | "medium" | "large";
  className?: string
}

const ToggleComponent: React.FunctionComponent<IToggleComponentProps> = (
  props
) => {
  const { enabled, color, onToggle } = props;

  const { iconOn, iconOff, className } = props;

  let size: SizeProp = "2x";
  switch(props.size){
    case "extraSmall" : { size = "lg"; break;} 
    case "small" : { size = "2x"; break;} 
    case "medium" : { size = "3x"; break;} 
    case "large" : { size = "4x"; break;} 
  }

  return (
    <div
      className={`toggle-control ${className}`}
      onClick={() => {
        if (typeof onToggle === "undefined") {
          return;
        }
        onToggle(!enabled);
      }}
    >
      <FontAwesomeIcon
        icon={enabled ? iconOn || faToggleOn : iconOff || faToggleOff}
        size={size}
        color={color}
      />
    </div>
  );
};

export default ToggleComponent;
